import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ReraDashboard from './components/ReraDashboard';
import AuctionDashboard from './components/AuctionDashboard';
import MahaReraDashboard from './components/MahaReraDashboard';
import LegalChatDashboard from './components/LegalChatDashboard'; // NEW: Legal Assistant

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* MP RERA Dashboard - ML predictions */}
        <Route path="/dashboard" element={<ReraDashboard />} />
        
        {/* MP Bank Auctions Dashboard */}
        <Route path="/auctions" element={<AuctionDashboard />} />
        
        {/* Maharashtra RERA Dashboard */}
        <Route path="/maha-rera" element={<MahaReraDashboard />} />
        
        {/* Legal Assistant - Document Analysis Chatbot */}
        <Route path="/legal-assistant" element={<LegalChatDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;